import { ModelInfo } from './model-info'
import { CompletedStateInfo } from './completed-state-info'

/**
 * Completed Content Service
 * @class Completed Content
 * @extends CompletedStateInfo
 * @property {string} lectureId 강의 ID
 * @property {string} attenderId 신청 ID
 * @property {string} title 교육명
 * @property {string} completedDate 완료일
 * @property {string} progressState 교육 상태
 */
export class CompletedInfoContent extends CompletedStateInfo {
  constructor(props) {
    super(props)
    this.lectureId = props.lectureId
    this.attenderId = props.attenderId
    this.title = props.title
    this.finishedAt = props.finishedAt
    this.progressState = props.progressState
    this.result = props.result
    this.materialFileExists = props.materialFileExists
  }
}

/**
 * CompletedInfo Service
 * @class CompletedInfo
 * @extends ModelInfo
 * @property {array} content 교육 정보
 */
export class CompletedInfo extends ModelInfo {
  constructor(props) {
    super(props)
    this.content = props.content.map((obj) => new CompletedInfoContent(obj))
  }
}
